module.exports = __webpack_public_path__ + "img/short-form-example-3.937a1435.png";